import {useDispatch} from "react-redux";
import {ACTION_TYPES} from "store/ActionTypes";

function useLoading() {
  const dispatch = useDispatch();
  const setLoading = (loading: boolean) => {
    dispatch({type: ACTION_TYPES.MAIN.LOADING, payload: loading});
  };
  return setLoading;
}

export default useLoading;